import Vue from 'vue';
import gsap from 'gsap';

Vue.component('tabs-component', {
    props: {
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            previousIndex: null,
            currentIndex: 0,
            inProgress: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.tabContentHolders = this.$el.querySelectorAll('.tab-block__content');

        this.setContainerHeight();

        EventBus.$on('window-resize', () => {
            this.setContainerHeight();
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        setContainerHeight() {
            gsap.set(this.$el.querySelector('.tab-block__content-holder'), {

                height: this.tabContentHolders[this.currentIndex].offsetHeight,

            });
        },

        setTab(index) {
            this.currentIndex = index;
        },
    },
});
